import React from "react";

import Text from "../../../components/Text";
import Link from "../../../components/Link";
import Editor from '../../../components/Editor';
import Button from "../../../components/Field/Button";
import Background from "../../../components/Background";

import style from './style.module.css';

export default function FeaturedArticle({ featuredList = [], buttonLabel = "", buttonLink = "", type = "desktop" }) {
    if (type === "desktop") {
        return (
            <div className={`${style.megaMenuRightColumnRow}`}>
                <div className={style.featuredList}>
                    <div className={style.featuredListInner}>
                        <div className={style.featuredListHeader}>
                            <Text className="megaMenuTitle" text="Featured Article" />
                        </div>
                        <div className={style.featuredListBody}>
                            {
                                featuredList.length > 0 && featuredList.map((article, findex) => {
                                    return (
                                        <div className={style.featuredListItem} key={`featuredListItem_${findex}_${article.sub_title}`}>
                                            <Link className={style.fullBlock} to={`/article/${article.url}`}></Link>
                                            <div className={style.featuredImage}>
                                                <div className={style.featuredImageWrap}>
                                                    <Background src={article.preview_image} size="140x90" />
                                                </div>
                                            </div>
                                            <div className={style.featuredTextContent}>
                                                <div className={style.featuredSubTitle}>
                                                    <Text className="size14" text={article.sub_title} />
                                                </div>
                                                <div className={style.featuredTitle}>
                                                    <Text className="size23" text={article.name} />
                                                </div>
                                                <div className={style.featuredDescription}>
                                                    <Editor className="size16" text={article.short_description} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={style.featuredListFooter}>
                            {
                                ((buttonLabel !== "" && buttonLink !== "") && <div>
                                    <Button link={buttonLink} label={buttonLabel} />
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (type === "mobile") {
        return (
            <div className={`${style.mobileMegaMenuRightColumnRow}`}>
                <div className={style.featuredList}>
                    <div className={style.featuredListInner}>
                        <div className={style.featuredListHeader}>
                            <Text className="megaMenuTitle" text="Featured Article" />
                        </div>
                        <div className={style.featuredListBody}>
                            {
                                featuredList.length > 0 && featuredList.map((article, index) => {
                                    return (
                                        <div className={style.featuredListItem} key={`mobileFeaturedListItem_${index}`}>
                                            <div className={style.featuredImage}>
                                                <div className={style.featuredImageWrap}>
                                                    <Background src={article.preview_image} size="140x90" />
                                                </div>
                                            </div>
                                            <div className={style.featuredTextContent}>
                                                <div className={style.featuredSubTitle}>
                                                    <Text className="size14" text={article.sub_title} />
                                                </div>
                                                <div className={style.featuredTitle}>
                                                    <Text className="size23" text={article.name} />
                                                </div>
                                                <div className={style.featuredDescription}>
                                                    <Editor className="size16" text={article.short_description} />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className={style.featuredListFooter}>
                            {
                                ((buttonLabel !== "" && buttonLink !== "") && <div>
                                    <Button link={buttonLink} label={buttonLabel} />
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    } else {
        return null;
    }
}